import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        Button,
        TextControl
    } = window.wp.components;

    const language = functions.getLang();
    const translator = {
        'en': {
            'enter_your_email': 'Enter your email',
            'recaptcha': `This site is protected with reCAPTCHA and applies to <a href="https://policies.google.com/privacy?hl=en" target="_blank">Google Privacy Policy</a> and <a href="https://policies.google.com/terms?hl=en" target="_blank">Terms of Service</a>.`,
            'consent': 'I consent to the e-mail of the latest offers and benefits.',
            'subscribe': 'Subscribe',
        },
        'de': {
            'enter_your_email': 'Geben Sie Ihre E-Mail-Adresse ein',
            'recaptcha': `Diese Website ist mit reCAPTCHA geschützt und unterliegt der <a href="https://policies.google.com/privacy?hl=en" target="_blank">Datenschutzbestimmungen von Google</a> und den <a href="https://policies.google.com/terms?hl=en" target="_blank">Nutzungsbedingungen</a>.`,
            'consent': 'Ich bin damit einverstanden, per E-Mail über aktuelle Angebote und Vorteile informiert zu werden.',
            'subscribe': 'Abonnieren',
        },
        'hr': {
            'enter_your_email': 'Unesite svoj email',
            'recaptcha': `Ova je stranica zaštićena reCAPTCHA-om i primjenjuje se na <a href="https://policies.google.com/privacy?hl=en" target="_blank">Googleova pravila o privatnosti</a> i <a href="https://policies.google.com/terms?hl=en" target="_blank">Uvjete pružanja usluge</a>.`,
            'consent': 'Slažem se s primanjem e-pošte o najnovijim ponudama i pogodnostima.',
            'subscribe': 'Pretplatite se',
        },
        'it': {
            'enter_your_email': 'Inserisci la tua email',
            'recaptcha': `Questo sito è protetto da reCAPTCHA e si applica all'<a href="https://policies.google.com/privacy?hl=it" target="_blank">Informativa sulla privacy di Google</a> e ai <a href="https://policies.google.com/terms?hl=it" target="_blank">Termini di servizio</a>.`,
            'consent': 'Acconsento a ricevere via email le ultime offerte e vantaggi.',
            'subscribe': 'Iscriviti',
        },
    };

    registerBlockType('custom-gutenberg/newsletter-section', {
        // built-in attributes
        title: 'Newsletter Section',
        description: 'Custom Newsletter Section',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            backgroundImage: {
                type: 'string',
                default: ''
            }, 
            titleKey: {
                type: 'string',
                default: 'We have the key'
            },
            subtitleKey: {
                type: 'string',
                default: 'unforgettable experiences <br />in Istria'
            },
            socialLabel: {
                type: 'string',
                default: 'Follow us on social media'
            },
            title: {
                type: 'string',
                default: 'Istrian villas & local gems'
            },
            subtitle: {
                type: 'string',
                default: 'Straight to your inbox'
            },
            description: {
                type: 'string',
                default: 'This newsletter brings you exclusive villas and the best of Istria - from table to trail, stone town to sea.'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                backgroundImage,
                titleKey,
                subtitleKey,
                socialLabel,
                title,
                subtitle,
                description,
            } = attributes;

            // custom functions
            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleKeyChange(titleKey) {
                setAttributes({titleKey: titleKey});
            }

            function onSubtitleKeyChange(subtitleKey) {
                setAttributes({subtitleKey: subtitleKey});
            }

            function onSocialLabelChange(socialLabel) {
                setAttributes({socialLabel: socialLabel});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onSubtitleChange(subtitle) {
                setAttributes({subtitle: subtitle});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }
            
            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <div>
                                    { backgroundImage && 
                                        <div>
                                            <figure>
                                                <img src={backgroundImage} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ backgroundImage: '' })} className="button">Remove</Button>
                                            </div>
                                            <br></br>
                                        </div>
                                
                                    }
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        Select Background Image
                                    </IconButton>
                                </div>
                            ) } />
                    </PanelBody>
                </InspectorControls>
                ,
                <section id="newsletter-section">
                    <div class="container-fluid">
                        <div class="row g-0">
                            <div class="col-lg-8">
                                <div class="newsletter-image">
                                    <div class="ozad cover-image bg-dark" style={{ height: 350 }} data-background-image={ backgroundImage }></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row h-100 g-0">
                            <div class="col-lg-6 py-5">
                                <RichText 
                                    key="editable" 
                                    tagName="h2" 
                                    className="h1 text-light mb-2 display-lg-3 display-xl-2"
                                    placeholder="We have the key" 
                                    value={ titleKey }
                                    onChange={ onTitleKeyChange } />
                                <RichText 
                                    key="editable" 
                                    tagName="h4" 
                                    className="h3 text-light mb-5 display-xl-4"
                                    placeholder="unforgettable experiences <br />in Istria" 
                                    value={ subtitleKey }
                                    onChange={ onSubtitleKeyChange } />

                                <RichText 
                                    key="editable" 
                                    tagName="p" 
                                    className="text-light"
                                    placeholder="Follow us on social media" 
                                    value={ socialLabel }
                                    onChange={ onSocialLabelChange } />
                                <div class="socila-links">
                                    <a target="_blank"><i class="fa-brands fa-facebook"></i></a>
                                    <a target="_blank"><i class="fa-brands fa-instagram"></i></a>
                                    <a target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                    <a target="_blank"><i class="fa-brands fa-youtube"></i></a>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="newsletter-box">
                                    <RichText 
                                        key="editable" 
                                        tagName="h4" 
                                        className="h2 mb-2"
                                        placeholder="Istrian villas & local gems" 
                                        value={ title }
                                        onChange={ onTitleChange } />
                                    <RichText 
                                        key="editable" 
                                        tagName="h5" 
                                        className="text-primary font-family-base"
                                        placeholder="Straight to your inbox" 
                                        value={ subtitle }
                                        onChange={ onSubtitleChange } />
                                    <RichText 
                                        key="editable" 
                                        tagName="p" 
                                        className="mb-4"
                                        placeholder="This newsletter brings you exclusive villas and the best of Istria - from table to trail, stone town to sea." 
                                        value={ description }
                                        onChange={ onDescriptionChange } />


                                    <form id="newsletter" class="newsletter-form">

                                        <p class="response-output"></p>

                                        <input required type="email" name="email" class="form-control" placeholder={ translator[language]['enter_your_email'] } />
                                        
                                        <div class="form-check my-3">
                                            <input class="form-check-input pointer" type="checkbox" value="" name="consent" id="consent" required />
                                            <label class="form-check-label small pointer" for="consent">{ translator[language]['consent'] }</label>
                                        </div>

                                        <RichText 
                                            tagName="p" 
                                            className="small"
                                            value={ translator[language]['recaptcha'] }/>

                                        <button class="btn btn-warning btn-newsletter text-white mt-lg-3 px-5">{ translator[language]['subscribe'] }</button>
                                        <div class="contact-spinner d-none spinner-border align-items-center justify-content-center mt-1 ms-2" role="status">
                                            <i class="fa-solid fa-envelope fa-lg"></i>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ]
            );
        },

        save({ attributes }) {

            const {
                backgroundImage,
                titleKey,
                subtitleKey,
                socialLabel,
                title,
                subtitle,
                description,
            } = attributes;

            return (
                <section id="newsletter-section">
                    <div class="container-fluid">
                        <div class="row h-100 g-0">
                            <div class="col-lg-8">
                                <div class="newsletter-image">
                                    <div class="lozad cover-image bg-dark" data-background-image={ backgroundImage }></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container pb-3 pb-lg-0">
                        <div class="row g-0">
                            <div class="col-lg-6 px-3 px-xxl-0 py-5">
                                <RichText.Content 
                                    tagName="h2" 
                                    className="h1 text-light mb-2 display-lg-3 display-xl-2"
                                    value={ titleKey }/>
                                <RichText.Content 
                                    tagName="h4" 
                                    className="h3 text-light mb-5 display-xl-4"
                                    value={ subtitleKey }/>

                                <RichText.Content 
                                    tagName="p" 
                                    className="text-light"
                                    value={ socialLabel }/>
                                <div class="socila-links">
                                    <a href="https://web.facebook.com/istrialux/" target="_blank"><i class="fa-brands fa-facebook"></i></a>
                                    <a href="https://www.instagram.com/istrialux/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
                                    <a href="https://www.linkedin.com/company/istrialux-agency/?viewAsMember=true" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                    <a href="https://www.youtube.com/@ISTRIALUXAgency" target="_blank"><i class="fa-brands fa-youtube"></i></a>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="newsletter-box">
                                    <RichText.Content 
                                        tagName="h4" 
                                        className="h2 mb-2"
                                        value={ title }/>
                                    <RichText.Content 
                                        tagName="h5" 
                                        className="text-primary font-family-base"
                                        value={ subtitle }/>
                                    <RichText.Content 
                                        tagName="p" 
                                        className="mb-4"
                                        value={ description }/>


                                    <form id="newsletter" class="newsletter-form load-recaptcha">

                                        <p class="response-output"></p>

                                        <input required type="email" name="email" class="form-control" placeholder={ translator[language]['enter_your_email'] } />
                                        
                                        <div class="form-check my-3">
                                            <input class="form-check-input pointer" type="checkbox" value="" name="consent" id="consent" required />
                                            <label class="form-check-label small pointer" for="consent">{ translator[language]['consent'] }</label>
                                        </div>

                                        <RichText.Content 
                                            tagName="p" 
                                            className="small"
                                            value={ translator[language]['recaptcha'] }/>

                                        <button class="btn btn-warning btn-newsletter text-white mt-lg-3 px-5">{ translator[language]['subscribe'] }</button>
                                        <div class="contact-spinner d-none spinner-border align-items-center justify-content-center mt-1 ms-2" role="status">
                                            <i class="fa-solid fa-envelope fa-lg"></i>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        },
    });
}